import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const r = new URLSearchParams(window.location.search).get("ref");
      if (r) localStorage.setItem("uc_ref", r.toUpperCase());
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    let ignore = false;
    const t = localStorage.getItem("uc_token");
    if (!t) { setLoading(false); return; }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => { if (!ignore) setUser(r.data.user); })
      .catch(() => localStorage.removeItem("uc_token"))
      .finally(() => { if (!ignore) setLoading(false); });
    return () => { ignore = true; };
  }, []);

  const persist = (token, usr) => {
    localStorage.setItem("uc_token", token);
    setUser(usr);
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    let ref = null;
    try { ref = new URLSearchParams(window.location.search).get("ref") || localStorage.getItem("uc_ref"); } catch { /* ignore */ }
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name, ref });
    persist(data.token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("uc_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}
